const languageChars = [
	{
		lang: 'en-GB',
		characters: {
			exemplarCharacters: 'a b c d e f g h i j k l m n o p q r s t u v w x y z',
			index: 'A B C D E F G H I J K L M N O P Q R S T U V W X Y Z',
			punctuation: "- ‐ – — , ; : ! ? . … ' ‘ ’ \" “ ” ( ) [ ] § @ * / & # † ‡ ′ ″",
		}
	},
	{
		lang: 'fr-FR',
		characters: {
			exemplarCharacters: 'a à â æ b c ç d e é è ê ë f g h i î ï j k l m n o ô œ p q r s t u ù û ü v w x y ÿ z',
			index: 'A B C D E F G H I J K L M N O P Q R S T U V W X Y Z',
			punctuation: '- ‐ – — , ; : ! ? . … ’ " “ ” « » ( ) [ ] § @ * / & # † ‡',
		}
	},
	{
		lang: 'pl-PL',
		characters: {
			exemplarCharacters: 'a ą b c ć d e ę f g h i j k l ł m n ń o ó p r s ś t u w y z ź ż',
			index: 'A Ą B C Ć D E Ę F G H I J K L Ł M N Ń O Ó P Q R S Ś T U V W X Y Z Ź Ż',
			punctuation: "- ‐ – — , ; : ! ? . … ' \" ” „ « » ( ) [ ] { } § @ * / & # % † ‡ ′ ″ ° ~",
		}
	},
	{
		lang: 'de-DE',
		characters: {
			exemplarCharacters: 'a ä b c d e f g h i j k l m n o ö p q r s ß t u ü v w x y z',
			index: 'A B C D E F G H I J K L M N O P Q R S T U V W X Y Z',
			punctuation: "- ‐ – — , ; : ! ? . … ' ‘ ‚ \" “ „ « » ( ) [ ] { } § @ * / & #",
		}
	},
	{
		lang: 'it-IT',
		characters: {
			exemplarCharacters: 'a à b c d e é è f g h i ì j k l m n o ó ò p q r s t u ù v w x y z',
			index: 'A B C D E F G H I J K L M N O P Q R S T U V W X Y Z',
			punctuation: '- — , ; : ! ? . … “ ” ( ) [ ] { } @ /',
		}
	},
	{
		lang: 'es-ES',
		characters: {
			exemplarCharacters: 'a á b c d e é f g h i í j k l m n ñ o ó p q r s t u ú ü v w x y z',
			index: 'A B C D E F G H I J K L M N Ñ O P Q R S T U V W X Y Z',
			punctuation: "- ‐ – — , ; : ! ¡ ? ¿ . … ' ‘ ’ \" “ ” « » ( ) [ ] § @ * / \\ & # † ‡ ′ ″",
		}
	}
];

export async function beforeStart() {
	const delayingStart: Promise<unknown>[] = [];
	if ('fonts' in document) {
		const { fonts } = document;
		if ('load' in fonts) {
			const set = new Set(languageChars.flatMap(v => [
				...v.characters.exemplarCharacters.split(' '),
				...v.characters.index.split(' '),
				...v.characters.punctuation.split(' ')
			]));
			// load font files depending on supported languages
			const allchars = Array.from(set).join('');
			delayingStart.push(Promise.all([
				fonts.load('300 16px \'VAG Rounded LT CYR\'', allchars),
				fonts.load('300 14px Roboto', allchars),
				fonts.load('400 14px Roboto', allchars),
				fonts.load('500 14px Roboto', allchars),
				fonts.load('700 14px Roboto', allchars),
				fonts.load('italic 300 14px Roboto', allchars),
				fonts.load('italic 400 14px Roboto', allchars),
				fonts.load('italic 500 14px Roboto', allchars),
				fonts.load('italic 700 14px Roboto', allchars)
			]).catch(err => {
				console.error('error loading fonts', err);
			}));
		}
	}
	await Promise.all(delayingStart);
}
